import { Routes } from '@angular/router';

import { ROUTE_NAMES } from '@constants';
import { i18nResolver, userBeanResolver } from 'src/app/core/resolvers';

export const calendarRoutes: Routes = [
  {
    path: 'events/:id',
    title: 'WEB_EVENT_AAA',
    resolve: {
      agorai18n: i18nResolver,
      userBean: userBeanResolver,
    },
    loadComponent: () =>
      import('./pages/event.component').then((m) => m.EventComponent),
    data: { navigationRoute: ROUTE_NAMES.EVENTS },
  },
  {
    path: 'calendar',
    title: 'WEB_CALENDAR_AAA',
    resolve: {
      agorai18n: i18nResolver,
      userBean: userBeanResolver,
    },
    loadComponent: () =>
      import('./pages/calendar.component').then((m) => m.CalendarComponent),
    data: { navigationRoute: ROUTE_NAMES.CALENDAR },
  },
];
